<span class="status {{status}}">{{ "TASK.STATUS." + status | translate}}</span>
